/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(window).on('load', function () {
  $(window)
    .scroll(function () {
      var windowBottom = $(this).scrollTop() + $(this).innerHeight() + 300
      $('.fadediv').each(function () {
        /* Check the location of each desired element */
        var objectBottom = $(this).offset().top + $(this).outerHeight()

        /* If the element is completely within bounds of the window, fade it in */
        if (objectBottom < windowBottom) {
          //object comes into view (scrolling down)
          if ($(this).css('opacity') == 0) {
            $(this).fadeTo(300, 1)
          }
        } else {
          //object goes out of view (scrolling up)
          if ($(this).css('opacity') == 1) {
            $(this).fadeTo(300, 0)
          }
        }
      })
    })
    .scroll() //invoke scroll-handler on page-load
})

$(document).ready(function () {
  setTimeout(function () {
    $('#showMe').fadeIn(1500)
  }, 3000)

  $(window).scroll(function () {
    if ($(this).scrollTop() >= 100) {
      // $('.Header__Wrapper').css({'padding-bottom': '0', transition: 'all .3s ease'})
      $('.Header__MainNav').css({'padding-bottom': '8px', transition: 'all .3s ease'})
      $('.Header__LogoImage').css({'max-width': '150px', transition: 'all .3s ease'})
      // $('body.template-index .Search').css({'top': '100%', transition: 'all .3s ease'})
    } else {
      $('.Header__Wrapper').css({'padding-bottom': '24px', transition: 'all .3s ease'})
      $('.Header__MainNav').css({'padding-bottom': '18px', transition: 'all .3s ease'})
      $('.Header__LogoImage').css({'max-width': '100%', transition: 'all .3s ease'})
      // $('body.template-index .Search').css({'top': '230%', transition: 'all .3s ease'})
    }
    if ($(this).scrollTop() > 500) {
      /* shopvote: set css for scrolltoTop-arrow */
      let vote = false
      const arrowDiv = document.querySelector('.scrolltoTop')
      const voteDiv = document.querySelector('#sv-rbadge-box')
      const voteDiv_mob = document.querySelector('#mobileRB1')

      voteDiv ? (vote = true) : (vote = false)

      if (vote === true) {
        let voteStyle = getComputedStyle(voteDiv)
        let voteStyle_mob = getComputedStyle(voteDiv_mob)
        let voteDisplay = voteStyle.display
        let voteDisplay_mob = voteStyle_mob.display

        if (voteDisplay === 'none' && voteDisplay_mob === 'none')
          arrowDiv.style.setProperty('bottom', '0px', 'important')
        else if (voteDisplay === 'none' && voteDisplay_mob != 'none')
          arrowDiv.style.setProperty('bottom', '60px', 'important')
        else arrowDiv.style.setProperty('bottom', '200px', 'important')
      } else {
        arrowDiv.style.setProperty('bottom', '0px', 'important')
      }

      /* END shopvote css */

      $('.scrolltoTop').fadeIn(1000)
    } else {
      $('.scrolltoTop').fadeOut(1000)
    }
  })
  $(document).on('click', '.trbo-content', function () {
    $('html, body').animate({scrollTop: 0}, 'slow')
    return false
  })

  $(document).on('click', '.HorizontalList__Item .SizeSwatch', function () {
    var unitprice = $(this).attr('data-unitprice'),
      gastatus = $(this).attr('data-gastatus'),
      deliverytime = $(this).attr('data-deliverytime')
    $('.wtper span').text(unitprice)
    $('.ProductMeta__PriceList').attr('data-gastatus', gastatus)
    $('.deliverytime span').text(deliverytime)
  })

  $('.prod_carousel').flickity({
    prevNextButtons: true,
    pageDots: false,
    wrapAround: true,
    contain: true,
    cellAlign: 'left',
    arrowShape: {x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25},
  })
  $('.SidebarMenu__Nav .submenu').each(function () {
    if ($(this).find('.Collapsible__Content .Collapsible').hasClass('site-nav--active')) {
      $(this).addClass('active')
    }
  })
  $(document).on('click', '.Icon-Wrapper--clickable[data-action="toggle-search"]', function () {
    $('body').toggleClass('search_enable')
  })
  $(document).on('click', '.Search__Close', function () {
    $('body').removeClass('search_enable')
  })
})

$(function () {
  var targets = $('[rel~=tooltip]'),
    target = false,
    tooltip = false,
    title = false

  targets.bind('mouseenter', function () {
    target = $(this)
    tip = target.attr('title')
    tooltip = $('<div id="tooltip"></div>')

    if (!tip || tip == '') return false

    target.removeAttr('title')
    tooltip.css('opacity', 0).html(tip).appendTo('body')

    var init_tooltip = function () {
      if ($(window).width() < tooltip.outerWidth() * 1.5) tooltip.css('max-width', $(window).width() / 1.8)
      else tooltip.css('max-width', 340)

      var pos_left = target.offset().left + target.outerWidth() / 2 - tooltip.outerWidth() / 2,
        pos_top = target.offset().top - tooltip.outerHeight() - 20

      if (pos_left < 0) {
        pos_left = target.offset().left + target.outerWidth() / 2 - 20
        tooltip.addClass('left')
      } else tooltip.removeClass('left')

      if (pos_left + tooltip.outerWidth() > $(window).width()) {
        pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20
        tooltip.addClass('right')
      } else tooltip.removeClass('right')

      // if (pos_top < 0) {
      // console.log(target)
      var pos_top = target[0].getBoundingClientRect().bottom
      tooltip.addClass('top')
      // } else tooltip.removeClass('top')

      tooltip.css({left: pos_left, top: pos_top, position: 'fixed'}).animate({top: '+=10', opacity: 1}, 50)
    }

    init_tooltip()
    $(window).resize(init_tooltip)

    var remove_tooltip = function () {
      tooltip.animate({top: '-=10', opacity: 0}, 50, function () {
        $(this).remove()
      })

      target.attr('title', tip)
    }

    target.bind('mouseleave', remove_tooltip)
    tooltip.bind('click', remove_tooltip)
  })
})

$(window).scroll(function () {
  document.documentElement.style.setProperty(
    '--header-height',
    document.getElementById('shopify-section-header').clientHeight + 'px'
  )
})

$(function () {
  var urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('toast')) {
    // Get the snackbar DIV
    var x = document.getElementById('snackbar')

    // Add the "show" class to DIV
    x.className = 'show'
    x.innerHTML = '<strong>' + urlParams.get('toast').toUpperCase() + '</strong>'

    // After 5 seconds, remove the show class from DIV
    setTimeout(function () {
      x.className = x.className.replace('show', '')
    }, 5000)
  }
})
